import { FC } from 'react'
import classes from "./UserManual.module.scss"

export const UserManual: FC = () => {
  return (
    <section className={classes.wrapper}>
      <h1>UserManual</h1>
    </section>
  )
}
